import {useEffect, useRef} from 'react';
import { usePlacesDropdownDismissal } from '../../../hooks/usePlacesDropdownDismissal';
import './ListingFormComponent.css';

type Props = {
  setShowModal?: (showModal: boolean) => void;
  index: number;
  btnType?: 'primary' | 'outline';
  children: JSX.Element[];
};

const clearGooglePlacesDropdowns = () => {
  // Google Places Autocomplete appends .pac-container to document.body and
  // can leave it visible when the Autocomplete input unmounts.
  document.querySelectorAll('.pac-container').forEach((el) => el.setAttribute('data-listing-dismissed', 'true'));
  const active = document.activeElement as HTMLElement | null;
  active?.blur?.();
};

export const ListingFormComponent = ({children, index}: Props) => {
  const formRoot = useRef<HTMLDivElement>(null);
  usePlacesDropdownDismissal(formRoot, index);
  const barProgress = ((index + 1) / children.length) * 100;

  useEffect(() => {
    clearGooglePlacesDropdowns();

    const forms = document.querySelectorAll('.needs-validation');

    // Loop over them and prevent submission
    Array.from(forms).forEach((form: any) => {
      form.addEventListener(
        'submit',
        (event: React.FormEvent<HTMLFormElement>) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add('was-validated');
        },
        false
      );
    });

    return () => {
      clearGooglePlacesDropdowns();
    };
  }, [index]);

  return (
    <div ref={formRoot}>
      <div className='progress border-round-top'>
        <div
          className='progress-bar'
          style={{width: `${barProgress}%`, backgroundColor: '#47bba9'}}
        ></div>
      </div>

      <div className='container p-4 px-md-5 justify-content-center'>
        <div className='col-12'>{children[index]}</div>
      </div>
    </div>
  );
};
